import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom";
import { supabase } from "./supabaseClient";

export default function ProtectedRoute({ children }) {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
    });
  }, []);

  if (session === undefined) {
    return null; // or a loading spinner
  }

  if (!session) {
    return <Navigate to="/" />;
  }

  return children;
}